import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="container-app py-24 text-center" data-testid="page-notfound">
            <div className="font-heading text-7xl font-extrabold text-primary">404</div>
            <h1 className="mt-4 font-heading text-3xl font-bold">Page not found</h1>
            <p className="mt-3 text-muted-foreground">The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
            <Link to="/" data-testid="notfound-home-link" className="mt-8 inline-flex items-center rounded-md bg-primary px-5 py-3 font-semibold text-white hover:bg-primary/90">Back to home</Link>
        </div>
    );
}
